import { useCallback, useRef } from "react";

export const useGetter = <T>(input: T): (() => T) => {
  const inputRef = useRef(input);
  inputRef.current = input;

  return useCallback(() => inputRef.current, []);
};
